import { render } from "./Creditcard_v2.vue?vue&type=template&id=1dbb2d74"
import script from "./Creditcard_v2.vue?vue&type=script&lang=js"
export * from "./Creditcard_v2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__